import { VStack } from "@gluestack-ui/themed";
import { MenuActionsList } from "@repo/core/components/layout/MenuActionsList";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { NewTransactionCaptureOptionsController } from "@repo/core/screens/NewTransaction/NewTransactionCaptureOptions/controller";

const NewTransactionCaptureOptions = () => {
  const {
    isMobile,
    menuActionItems,
    title,
    showConfirmStoreModal,
    navigateBack
  } = NewTransactionCaptureOptionsController();

  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect
        title={title}
        showConfirmStoreModal={showConfirmStoreModal}
        onBackPress={navigateBack}
      >
        <VStack
          space="lg"
          alignItems={isMobile ? "flex-start" : "center"}
          pt="$3"
          px={isMobile ? "$4" : "$6"}
          w="$full"
        >
          <MenuActionsList
            title="Meio de captura"
            menuItems={menuActionItems}
          />
        </VStack>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};

export default NewTransactionCaptureOptions;
